import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import reducers from './reducers'
import thunk from 'redux-thunk'

import { loadState, saveState } from './localStorage'


// Redux
// Export configureStore() instead of just the store object, so that tests have
// the ability to create as many stores as they want.

const configureStore = () => {
  const persistentState = loadState()

  const store = createStore(
    reducers,
    persistentState,
    applyMiddleware(thunk)
  )

  store.subscribe(() => {
    console.log(store.getState())
    saveState(store.getState())
  })

  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/configureStore.js